export const MONITORING_TABS = [
	{ id: "overview", label: "Overview" },
	{ id: "history", label: "History" },
	{ id: "prompts", label: "Prompts" },
	{ id: "analysis", label: "Analysis" },
	{ id: "competitors", label: "Competitors" },
	{ id: "prompt-research", label: "Prompt Research" },
	{ id: "ai-traffic", label: "AI Traffic" },
	{ id: "alerts", label: "Alerts" },
	{ id: "settings", label: "Settings" },
];

export const monitoringMock = {
	project: {
		hostname: "cocotherapy.com",
		status: "active",
		orgId: "7k2mq4tx",
		siteId: "cspc9fm8",
		orgName: "PetTech Retail Group",
		appId: "cb_grader_…41b7",
	},
	metrics: {
		shareOfVoice: {
			value: 27,
			deltaPts: 2,
			deltaLabel: "this week",
			scope: "Unbranded",
		},
		citationRate: {
			value: 41,
			unitLabel: "% of engine answers",
			cited: 138,
			total: 336,
			windowLabel: "latest run",
			sparkline: [28, 32, 30, 35, 38, 36, 40, 39, 42, 41, 43, 41],
			avg7d: 41,
			runCount: 4,
		},
		mentionRate: {
			value: 58,
			brandWithoutLinkPct: 17,
			sparkline: [48, 50, 52, 51, 54, 55, 53, 56, 57, 58, 59, 58],
		},
		latestScores: {
			aeo: { value: 71, delta: 3 },
			geo: { value: 68, delta: 6 },
			reAuditLabel: "Re-audit of Jul 6",
		},
	},
	sovByEngine: [
		{ week: "W1", openai: 18, gemini: 12, claude: 8, perplexity: 22, aiOverviews: 10 },
		{ week: "W2", openai: 20, gemini: 14, claude: 9, perplexity: 24, aiOverviews: 11 },
		{ week: "W3", openai: 19, gemini: 15, claude: 11, perplexity: 21, aiOverviews: 12 },
		{ week: "W4", openai: 22, gemini: 16, claude: 12, perplexity: 25, aiOverviews: 14 },
		{ week: "W5", openai: 24, gemini: 18, claude: 13, perplexity: 27, aiOverviews: 15 },
		{ week: "W6", openai: 23, gemini: 17, claude: 14, perplexity: 26, aiOverviews: 16 },
		{ week: "W7", openai: 25, gemini: 19, claude: 15, perplexity: 28, aiOverviews: 17 },
		{ week: "W8", openai: 27, gemini: 20, claude: 16, perplexity: 30, aiOverviews: 18 },
		{ week: "W9", openai: 26, gemini: 21, claude: 17, perplexity: 29, aiOverviews: 19 },
		{ week: "W10", openai: 28, gemini: 22, claude: 18, perplexity: 31, aiOverviews: 20 },
		{ week: "W11", openai: 29, gemini: 23, claude: 19, perplexity: 32, aiOverviews: 21 },
		{ week: "W12", openai: 30, gemini: 24, claude: 20, perplexity: 33, aiOverviews: 22 },
	],
	spend: {
		used: 23.14,
		cap: 40.0,
		pct: 58,
		daysElapsed: 22,
		projected: 31.8,
	},
	attention: [
		{
			type: "alert",
			message: "Perplexity citations lost on 2 prompts since Jul 6 — see Alerts.",
		},
		{
			type: "journal",
			message: "Competitor zestypaws.com overtook on 'dog coat supplement' prompt cluster.",
		},
	],
	history: {
		scoreSeries: [
			{ date: "5/18", aeo: 58, geo: 52 },
			{ date: "5/25", aeo: 60, geo: 54 },
			{ date: "6/1", aeo: 61, geo: 56 },
			{ date: "6/8", aeo: 63, geo: 58 },
			{ date: "6/15", aeo: 64, geo: 60 },
			{ date: "6/22", aeo: 66, geo: 62 },
			{ date: "6/29", aeo: 66, geo: 63 },
			{ date: "7/6", aeo: 68, geo: 66 },
			{ date: "7/13", aeo: 71, geo: 68 },
		],
		changeEvents: [
			{
				id: "evt-1",
				date: "JUL 6",
				category: "WEEKLY RE-AUDIT",
				type: "audit",
				headline: "GEO 62 → 68 · llms.txt detected",
				detail: "Structured-data coverage +9 pages",
				reportLink: true,
			},
			{
				id: "evt-2",
				date: "JUL 6",
				category: "DAILY PROMPT RUN",
				type: "alert",
				headline: "Lost Perplexity citation on 2 prompts",
				detail:
					"“best organic coconut oil for dogs”, “coconut oil dog skin allergies” — alert sent",
			},
			{
				id: "evt-3",
				date: "JUL 2",
				category: "DAILY PROMPT RUN",
				type: "gain",
				headline: "Gained Claude citation on 3 prompts",
				detail: "First citations for the “digestive health” prompt cluster",
			},
			{
				id: "evt-4",
				date: "JUN 29",
				category: "WEEKLY RE-AUDIT",
				type: "alert",
				headline: "AEO 66 → 68 · 4 pages returned 404 to GPTBot",
				detail: "/blog/coconut-oil-guide moved without redirect",
			},
			{
				id: "evt-5",
				date: "JUN 22",
				category: "SETTINGS",
				type: "settings",
				headline: "Prompt cap raised 40 → 50",
				detail: "By App cb_grader_...41b7 via PATCH /projects",
			},
		],
		citationTimeline: {
			dates: ["6/15", "6/18", "6/22", "6/25", "6/29", "7/2", "7/6", "7/9", "Today"],
			prompts: [
				{
					id: "ct-1",
					label: "best organic coconut oil for dogs",
					cells: [
						"cited",
						"cited",
						"cited",
						"cited",
						"cited",
						"cited",
						"cited",
						"cited",
						"cited",
					],
					summary: "Cited 9/9",
					summaryKind: "cited",
				},
				{
					id: "ct-2",
					label: "coconut oil dog skin allergies",
					cells: [
						"cited",
						"cited",
						"cited",
						"cited",
						"cited",
						"cited",
						"lost",
						"not",
						"not",
					],
					summary: "Lost 7/6",
					summaryKind: "lost",
				},
				{
					id: "ct-3",
					label: "is coconut oil safe for puppies",
					cells: [
						"not",
						"not",
						"cited",
						"cited",
						"cited",
						"cited",
						"cited",
						"cited",
						"cited",
					],
					summary: "Cited 7/9",
					summaryKind: "cited",
				},
				{
					id: "ct-4",
					label: "natural remedies for dog digestion",
					cells: [
						"not",
						"not",
						"cited",
						"cited",
						"cited",
						"cited",
						"cited",
						"cited",
						"lost",
					],
					summary: "Lost Now",
					summaryKind: "lost",
					retired: true,
				},
				{
					id: "ct-5",
					label: "coconut oil vs salmon oil for coat",
					cells: ["not", "not", "not", "not", "not", "not", "not", "not", "not"],
					summary: "Never cited",
					summaryKind: "never",
				},
			],
		},
	},
	prompts: {
		filters: {
			engines: ["All engines", "GPT", "Gemini", "Claude", "Perplexity"],
			sources: ["All sources", "Baseline audit", "Manual", "AI suggested"],
			locales: ["en-US", "en-GB", "de-DE"],
		},
		totalCount: 50,
		rows: [
			{
				id: "p1",
				prompt: "best organic coconut oil for dogs",
				source: "baseline",
				sourceLabel: "Baseline audit",
				enginesCited: ["GPT", "Gemini", "Claude"],
				cited: "3/5",
				avgPosition: 2.1,
				sentiment: "positive",
				trend: [1, 1, 2, 2, 3, 3, 3, 3],
				trendDeclining: false,
				detail: {
					series: [
						{ date: "6/15", count: 0 },
						{ date: "6/22", count: 1 },
						{ date: "6/29", count: 2 },
						{ date: "7/2", count: 3 },
						{ date: "7/6", count: 3 },
						{ date: "7/13", count: 3 },
					],
					narrative:
						"First cited Jun 22 (Gemini). Claude joined Jul 2. Perplexity cited Jun 25 – Jul 2, lost Jul 6. Latest answer cites /products/organic-virgin-coconut-oil.",
					lossPhrase: "lost Jul 6",
				},
			},
			{
				id: "p2",
				prompt: "coconut oil dog skin allergies",
				source: "manual",
				sourceLabel: "Manual",
				enginesCited: ["GPT", "Perplexity"],
				cited: "2/5",
				avgPosition: 3.4,
				sentiment: "neutral",
				trend: [3, 3, 3, 2, 2, 1, 1, 1],
				trendDeclining: true,
				detail: {
					series: [
						{ date: "6/15", count: 3 },
						{ date: "6/22", count: 3 },
						{ date: "6/29", count: 2 },
						{ date: "7/2", count: 2 },
						{ date: "7/6", count: 1 },
						{ date: "7/13", count: 1 },
					],
					narrative:
						"Strong on GPT through June. Perplexity citation lost Jul 6. Gemini never cited. Latest answer mentions brand without link.",
					lossPhrase: "lost Jul 6",
				},
			},
			{
				id: "p3",
				prompt: "is coconut oil safe for puppies",
				source: "ai",
				sourceLabel: "AI suggested",
				enginesCited: ["Gemini", "Claude"],
				cited: "2/5",
				avgPosition: 2.8,
				sentiment: "positive",
				trend: [0, 1, 1, 2, 2, 2, 2, 2],
				trendDeclining: false,
				detail: {
					series: [
						{ date: "6/15", count: 0 },
						{ date: "6/22", count: 1 },
						{ date: "6/29", count: 1 },
						{ date: "7/2", count: 2 },
						{ date: "7/6", count: 2 },
						{ date: "7/13", count: 2 },
					],
					narrative:
						"First cited Jun 22 (Gemini). Claude joined Jul 2. Stable since — no losses this window.",
					lossPhrase: null,
				},
			},
			{
				id: "p4",
				prompt: "organic virgin coconut oil pets",
				source: "baseline",
				sourceLabel: "Baseline audit",
				enginesCited: ["GPT", "Gemini", "Claude", "Perplexity"],
				cited: "4/5",
				avgPosition: 1.9,
				sentiment: "positive",
				trend: [2, 3, 3, 4, 4, 4, 4, 4],
				trendDeclining: false,
				detail: {
					series: [
						{ date: "6/15", count: 2 },
						{ date: "6/22", count: 3 },
						{ date: "6/29", count: 3 },
						{ date: "7/2", count: 4 },
						{ date: "7/6", count: 4 },
						{ date: "7/13", count: 4 },
					],
					narrative:
						"Broad engine coverage. Perplexity joined Jul 2. Top cited URL: /products/organic-virgin-coconut-oil.",
					lossPhrase: null,
				},
			},
			{
				id: "p5",
				prompt: "dog coat supplement coconut oil",
				source: "manual",
				sourceLabel: "Manual",
				enginesCited: ["GPT"],
				cited: "1/5",
				avgPosition: 4.2,
				sentiment: "neutral",
				trend: [2, 2, 2, 2, 1, 1, 0, 0],
				trendDeclining: true,
				detail: {
					series: [
						{ date: "6/15", count: 2 },
						{ date: "6/22", count: 2 },
						{ date: "6/29", count: 2 },
						{ date: "7/2", count: 1 },
						{ date: "7/6", count: 0 },
						{ date: "7/13", count: 0 },
					],
					narrative:
						"zestypaws.com overtook this cluster. GPT citation lost Jul 6. No engines citing as of latest run.",
					lossPhrase: "lost Jul 6",
				},
			},
		],
	},
	competitors: {
		sovSeries: [
			{
				week: "W1",
				us: 18,
				zestypaws: 22,
				nativepet: 14,
				chewy: 20,
				other: 26,
			},
			{
				week: "W2",
				us: 19,
				zestypaws: 21,
				nativepet: 15,
				chewy: 19,
				other: 26,
			},
			{
				week: "W3",
				us: 21,
				zestypaws: 20,
				nativepet: 14,
				chewy: 18,
				other: 27,
			},
			{
				week: "W4",
				us: 22,
				zestypaws: 20,
				nativepet: 15,
				chewy: 18,
				other: 25,
			},
			{
				week: "W5",
				us: 24,
				zestypaws: 19,
				nativepet: 14,
				chewy: 17,
				other: 26,
			},
			{
				week: "W6",
				us: 25,
				zestypaws: 19,
				nativepet: 13,
				chewy: 17,
				other: 26,
			},
			{
				week: "W7",
				us: 26,
				zestypaws: 18,
				nativepet: 14,
				chewy: 16,
				other: 26,
			},
			{
				week: "W8",
				us: 27,
				zestypaws: 18,
				nativepet: 13,
				chewy: 16,
				other: 26,
			},
		],
		sovLegend: [
			{ key: "us", label: "cocotherapy.com (us)", color: "#312E81" },
			{ key: "zestypaws", label: "zestypaws.com", color: "#4F46E5" },
			{ key: "nativepet", label: "nativepet.com", color: "#818CF8" },
			{ key: "chewy", label: "chewy.com", color: "#A5B4FC" },
			{ key: "other", label: "Other", color: "#D1D5DB" },
		],
		citationSources: [
			{ domain: "zestypaws.com", citations30d: 48, overlapPct: 62 },
			{ domain: "nativepet.com", citations30d: 31, overlapPct: 44 },
			{ domain: "chewy.com", citations30d: 27, overlapPct: 38 },
			{ domain: "petmd.com", citations30d: 19, overlapPct: 22 },
			{ domain: "akc.org", citations30d: 14, overlapPct: 18 },
			{ domain: "rover.com", citations30d: 11, overlapPct: 15 },
		],
		winLossMatrix: {
			rows: [
				{ cluster: "Coconut oil basics", prompts: 8 },
				{ cluster: "Skin & coat", prompts: 6 },
				{ cluster: "Puppy safety", prompts: 5 },
				{ cluster: "Supplements", prompts: 7 },
			],
			competitors: ["zestypaws.com", "nativepet.com", "chewy.com"],
			cells: {
				"Coconut oil basics": {
					"zestypaws.com": { status: "lead", us: 6, them: 2, tied: 0 },
					"nativepet.com": { status: "lead", us: 5, them: 3, tied: 0 },
					"chewy.com": { status: "tied", us: 4, them: 4, tied: 1 },
				},
				"Skin & coat": {
					"zestypaws.com": { status: "behind", us: 4, them: 7, tied: 0 },
					"nativepet.com": { status: "tied", us: 5, them: 5, tied: 0 },
					"chewy.com": { status: "lead", us: 6, them: 3, tied: 0 },
				},
				"Puppy safety": {
					"zestypaws.com": { status: "lead", us: 5, them: 2, tied: 0 },
					"nativepet.com": { status: "lead", us: 7, them: 1, tied: 0 },
					"chewy.com": { status: "behind", us: 3, them: 5, tied: 0 },
				},
				Supplements: {
					"zestypaws.com": { status: "behind", us: 2, them: 8, tied: 0 },
					"nativepet.com": { status: "behind", us: 3, them: 6, tied: 0 },
					"chewy.com": { status: "tied", us: 4, them: 4, tied: 0 },
				},
			},
			footnote: "3 competitors added manually · 2 auto-discovered from citation overlap",
		},
	},
	keywords: [
		{
			id: "kw-1",
			keyword: "coconut oil for dogs",
			volume: 8100,
			difficulty: 34,
			intent: "informational",
			mappedPrompts: 4,
			citedOnMapped: { cited: 3, total: 4 },
		},
		{
			id: "kw-2",
			keyword: "organic dog supplements",
			volume: 4400,
			difficulty: 48,
			intent: "commercial",
			mappedPrompts: 3,
			citedOnMapped: { cited: 1, total: 3 },
		},
		{
			id: "kw-3",
			keyword: "buy virgin coconut oil pets",
			volume: 720,
			difficulty: 22,
			intent: "transactional",
			mappedPrompts: null,
			citedOnMapped: null,
		},
		{
			id: "kw-4",
			keyword: "dog coat supplement",
			volume: 2900,
			difficulty: 41,
			intent: "commercial",
			mappedPrompts: 2,
			citedOnMapped: { cited: 0, total: 2 },
		},
		{
			id: "kw-5",
			keyword: "mct oil for pets",
			volume: 1600,
			difficulty: 29,
			intent: "informational",
			mappedPrompts: 5,
			citedOnMapped: { cited: 4, total: 5 },
		},
	],
	aiTraffic: {
		dataSource: "cloudflare",
		metrics: {
			botCrawls: { value: 1284, deltaPct: 18, windowLabel: "7D" },
			referralVisits: { value: 312, deltaPct: 9, windowLabel: "7D" },
			citationCtr: {
				value: 2.3,
				hint: "visits ÷ estimated answer impressions",
			},
			bot404s: { value: 47, urlsAffected: 4 },
		},
		crawlsSeries: [
			{ day: "Jun 26", gptBot: 72, claudeBot: 38, perplexityBot: 55, googleExtended: 28 },
			{ day: "Jun 27", gptBot: 78, claudeBot: 42, perplexityBot: 58, googleExtended: 30 },
			{ day: "Jun 28", gptBot: 85, claudeBot: 45, perplexityBot: 62, googleExtended: 32 },
			{ day: "Jun 29", gptBot: 90, claudeBot: 48, perplexityBot: 70, googleExtended: 35 },
			{ day: "Jun 30", gptBot: 95, claudeBot: 52, perplexityBot: 75, googleExtended: 38 },
			{ day: "Jul 1", gptBot: 88, claudeBot: 50, perplexityBot: 68, googleExtended: 36 },
			{ day: "Jul 2", gptBot: 102, claudeBot: 55, perplexityBot: 82, googleExtended: 40 },
			{ day: "Jul 3", gptBot: 110, claudeBot: 58, perplexityBot: 88, googleExtended: 42 },
			{ day: "Jul 4", gptBot: 98, claudeBot: 54, perplexityBot: 80, googleExtended: 39 },
			{ day: "Jul 5", gptBot: 115, claudeBot: 62, perplexityBot: 95, googleExtended: 45 },
			{ day: "Jul 6", gptBot: 120, claudeBot: 65, perplexityBot: 102, googleExtended: 48 },
			{ day: "Jul 7", gptBot: 108, claudeBot: 60, perplexityBot: 90, googleExtended: 44 },
			{ day: "Jul 8", gptBot: 125, claudeBot: 68, perplexityBot: 110, googleExtended: 50 },
			{ day: "Jul 9", gptBot: 130, claudeBot: 70, perplexityBot: 115, googleExtended: 52 },
		],
		topPages: [
			{ page: "/products/virgin-coconut-oil", referrer: "chatgpt.com", visits: 84 },
			{ page: "/blog/coconut-oil-for-dogs", referrer: "perplexity.ai", visits: 61 },
			{
				page: "/blog/coconut-oil-guide",
				referrer: "chatgpt.com",
				visits: 22,
				status: 404,
			},
			{ page: "/collections/pet-supplements", referrer: "claude.ai", visits: 19 },
			{ page: "/pages/about", referrer: "perplexity.ai", visits: 14 },
		],
	},
	alerts: {
		feed: [
			{
				id: "al-1",
				severity: "loss",
				title: "Citation lost",
				timestamp: "Jul 6, 06:12",
				detail: "Perplexity dropped 2 citations on 'coconut oil for dogs' cluster. Emailed team@ • Slack #ai-visibility",
				status: "open",
			},
			{
				id: "al-2",
				severity: "warning",
				title: "Competitor overtake",
				timestamp: "Jul 5, 14:40",
				detail: "zestypaws.com overtook on 'dog coat supplement' prompt cluster.",
				status: "open",
			},
			{
				id: "al-3",
				severity: "info",
				title: "GEO score improved",
				timestamp: "Jul 4, 09:18",
				detail: "GEO +6 pts after llms.txt refresh and FAQ schema deploy.",
				status: "resolved",
			},
			{
				id: "al-4",
				severity: "warning",
				title: "AI bots hitting 404s",
				timestamp: "Jul 3, 22:05",
				detail: "47 bot hits on 4 URLs — see AI Traffic for broken paths.",
				status: "open",
			},
		],
		rules: [
			{
				id: "rule-1",
				label: "Share of voice drops > 10%",
				meta: "Window: 7 days • Channels: email, Slack",
				enabled: true,
			},
			{
				id: "rule-2",
				label: "Citation lost on mapped prompt",
				meta: "Window: 24 hours • Channels: email, Slack",
				enabled: true,
			},
			{
				id: "rule-3",
				label: "Competitor overtake on prompt cluster",
				meta: "Window: 7 days • Channels: Slack",
				enabled: true,
			},
			{
				id: "rule-4",
				label: "Bot 404 spike > 20 hits / day",
				meta: "Window: 24 hours • Channels: email",
				enabled: false,
			},
			{
				id: "rule-5",
				label: "GEO / AEO score drop > 5 pts",
				meta: "Window: 7 days • Channels: email, Slack",
				enabled: true,
			},
		],
		digest: "Weekly digest: On — Mondays 08:00 UTC",
	},
};

export const ENGINE_SERIES = [
	{ key: "openai", label: "OpenAI", color: "#4F46E5" },
	{ key: "gemini", label: "Gemini", color: "#0EA5E9" },
	{ key: "claude", label: "Claude", color: "#F59E0B" },
	{ key: "perplexity", label: "Perplexity", color: "#10B981" },
	{ key: "aiOverviews", label: "AI Overviews", color: "#EC4899" },
];

export const BOT_SERIES = [
	{ key: "gptBot", label: "GPTBot", color: "#4F46E5" },
	{ key: "claudeBot", label: "ClaudeBot", color: "#7C3AED" },
	{ key: "perplexityBot", label: "PerplexityBot", color: "#EA580C" },
	{ key: "googleExtended", label: "Google-Extended", color: "#9CA3AF" },
];

export const INTENT_LABELS = {
	informational: "Informational",
	commercial: "Commercial",
	transactional: "Transactional",
};
